import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'

import styles from './styles'

import Typewriter from 'typewriter-effect'

const decorators = [
  memoized,
]

function TextTypeWriter(props) {
  const { className, strings } = props

  return (
    <div className={classnames('text-writer', className)}>
      <Typewriter options={{ strings, autoStart: true, loop: true }} />
      <style jsx>{styles}</style>
    </div>
  )
}

TextTypeWriter.propTypes = {
  strings: PropTypes.arrayOf(PropTypes.string),
}

TextTypeWriter.defaultProps = {
  strings: [],
}

TextTypeWriter = chainDecorators(decorators, TextTypeWriter)

export default TextTypeWriter
